/**
 * Shared visual tokens — dark theme, cyan accent.
 * Keep in sync with dictomate_reactnative/app/src/theme/tokens.ts.
 */
export const colors = {
  background: '#121416',
  surface: '#1a1d21',
  surfaceMuted: '#16191c',
  surfaceAccentTint: 'rgba(38, 230, 230, 0.12)',
  border: '#3E474D',
  text: '#FFFFFF',
  textMuted: '#A0A0A0',
  accent: '#26E6E6',
  onAccent: '#121416',
  accentMuted: 'rgba(38, 230, 230, 0.4)',
  secondaryButtonBg: '#455A64',
  secondaryButtonText: '#A0A0A0',
  danger: '#E85D5D',
  onDanger: '#FFFFFF',
  inputBg: '#1e2328',
  errorTintBg: 'rgba(232, 93, 93, 0.18)',
  errorTintBorder: 'rgba(232, 93, 93, 0.45)',
  success: '#2EA043',
  successTintBg: 'rgba(46, 160, 67, 0.16)',
  successTintBorder: 'rgba(46, 160, 67, 0.4)',
  rowActiveBorder: 'rgba(38, 230, 230, 0.5)',
  rowActiveBg: 'rgba(38, 230, 230, 0.08)',
  modalOverlay: 'rgba(0, 0, 0, 0.65)',
  pressedOverlay: 'rgba(255, 255, 255, 0.06)',
} as const;

export const radii = {
  sm: 10,
  md: 14,
} as const;
